export var SPLIT_KILLED = 'killed';
export var NO_CONDITION_MATCH = 'default rule';
export var SPLIT_NOT_FOUND = 'definition not found';
export var SDK_NOT_READY = 'not ready';
export var EXCEPTION = 'exception';
export var SPLIT_ARCHIVED = 'archived';
export var NOT_IN_SPLIT = 'not in split';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/labels/index.js
// module id = 483
// module chunks = 25